import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Form, Input, Select } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { GetCountryDetailsApi } from "../../../api/request/countryDetail";
import { CreateClientApi } from "../../../api/request/clients/clients";

const { Option } = Select;

const AddClientModal = ({ isOpen, setIsOpen, getClientList }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [countryDetails, setCountryDetails] = useState([]);

  const getCountryDetails = async () => {
    try {
      const { data } = await GetCountryDetailsApi();
      if (data?.status) setCountryDetails(data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    getCountryDetails();
  }, []);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const { data } = await CreateClientApi(values);
      if (data?.status) {
        form.resetFields();
        toast.success(data?.message);
        setIsOpen(false);
        getClientList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      form.resetFields();
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title="Add Client">
      <Form
        autoComplete="off"
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
      >
        <div className="grid lg:grid-flow-col gap-4">
          <Form.Item
            label="First Name"
            name="first_name"
            rules={[{ required: true, message: "Please enter first name." }]}
          >
            <Input placeholder="First Name" size="large" />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="last_name"
            rules={[{ required: true, message: "Please enter last name." }]}
          >
            <Input placeholder="Last Name" size="large" />
          </Form.Item>
        </div>
        <div className="flex sm:flex-row flex-col sm:gap-5">
          <Form.Item
            label="Country Code"
            name="country_code"
            className="sm:min-w-[28%]"
          >
            <Select placeholder="Country code" size="large">
              {countryDetails.map((countryData, index) => (
                <Option key={index} value={countryData?.id}>
                  <div className="flex items-center space-x-3">
                    <div className="rounded-full bg-secondaryLight w-9 h-9 flex justify-center items-center">
                      <img
                        src={countryData?.image}
                        alt="flag"
                        className="w-7 h-7 object-contain rounded-full"
                      />
                    </div>
                    <span className="text-base">
                      + {countryData?.phonecode}
                    </span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Mobile No."
            name="mobile_no"
            rules={[
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter 10 digits mobile number",
              },
            ]}
            className="w-full"
          >
            <Input type="number" placeholder="Mobile No." size="large" />
          </Form.Item>
        </div>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter email address" },
            { type: "email", message: "Please enter valid email address" },
          ]}
        >
          <Input placeholder="Email" size="large" />
        </Form.Item>

        <div className="flex justify-center mt-5">
          <LoadableButton
            className="bg-secondary text-white uppercase text-base font-semibold px-6 py-2 rounded-lg mt-2"
            type="submit"
            lable="Submit"
            loadingLable="Adding Client..."
            isLoading={isLoading}
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default AddClientModal;
